import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const accentStyles: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
};

export default function CategoryEntries() {
  return (
    <section className="mt-10">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">
            分类快捷入口
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按你喜欢的类型，快速进入专属频道</p>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((cat) => {
          const style = accentStyles[cat.accent] ?? accentStyles.primary;
          return (
            <Link
              key={cat.type}
              to={`/category/${cat.type}`}
              className="group flex flex-col gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
            >
              <span className={`w-14 h-14 flex items-center justify-center rounded-lg ${style.bg} ${style.text}`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-1.5">
                  {cat.label}
                  <i className="ri-arrow-right-line text-base text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-2">{cat.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}